var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 57,
    viewBox: "0 0 95 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.951 56.8361C46.6332 56.8361 46.3365 56.7521 46.0617 56.6061L43.242 54.9491C42.8183 54.7191 43.0302 54.6341 43.1571 54.5921C43.7296 54.4021 43.8365 54.3621 44.429 54.0261C44.493 53.9841 44.5789 54.0061 44.6408 54.0461L46.8031 55.3261C46.888 55.3681 46.9929 55.3681 47.0569 55.3261L55.516 50.4801C55.6009 50.4381 55.6429 50.3541 55.6429 50.2501V40.5781C55.6429 40.4731 55.5999 40.3881 55.516 40.3481L47.0569 35.5231C46.972 35.4811 46.867 35.4811 46.8031 35.5231L38.344 40.3481C38.259 40.3901 38.2171 40.4951 38.2171 40.5781V50.2501C38.2171 50.3341 38.26 50.4401 38.344 50.4801L40.6551 51.8021C41.9061 52.4321 42.6904 51.6971 42.6904 50.9621V41.4161C42.6904 41.2901 42.7963 41.1641 42.9452 41.1641H44.0263C44.1532 41.1641 44.2811 41.2691 44.2811 41.4161V50.9621C44.2811 52.6191 43.3699 53.5851 41.7792 53.5851C41.2916 53.5851 40.9099 53.5851 39.8288 53.0601L37.6026 51.8001C37.051 51.4851 36.7133 50.8981 36.7133 50.2681V40.5961C36.7133 39.9661 37.053 39.3791 37.6026 39.0641L46.0617 34.2181C46.5913 33.9241 47.3127 33.9241 47.8432 34.2181L56.3024 39.0641C56.8539 39.3791 57.1917 39.9661 57.1917 40.5961V50.2681C57.1917 50.8981 56.8519 51.4851 56.3024 51.8001L47.8432 56.6461C47.563 56.7709 47.2597 56.8353 46.953 56.8351L46.951 56.8361ZM49.5489 50.1861C45.8389 50.1861 45.0755 48.5081 45.0755 47.0811C45.0755 46.9551 45.1814 46.8291 45.3303 46.8291H46.4324C46.5593 46.8291 46.6652 46.9131 46.6652 47.0291C46.8351 48.1411 47.3227 48.6861 49.5698 48.6861C51.3504 48.6861 52.1138 48.2861 52.1138 47.3431C52.1138 46.7981 51.9019 46.3991 49.1242 46.1261C46.8131 45.8961 45.3713 45.3921 45.3713 43.5661C45.3713 41.8661 46.8131 40.8591 49.2301 40.8591C51.9439 40.8591 53.2798 41.7821 53.4497 43.7961C53.4497 43.8591 53.4297 43.9221 53.3857 43.9861C53.3428 44.0281 53.2798 44.0701 53.2159 44.0701H52.1138C52.0079 44.0701 51.9019 43.9861 51.881 43.8801C51.6262 42.7261 50.9697 42.3481 49.2311 42.3481C47.2807 42.3481 47.0469 43.0181 47.0469 43.5231C47.0469 44.1311 47.3227 44.3201 49.9515 44.6561C52.5494 44.9921 53.7884 45.4741 53.7884 47.2791C53.7684 49.1251 52.2397 50.1741 49.5479 50.1741L49.5489 50.1861Z",
    fill: "#539E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7023 19.0081C20.7023 18.6301 20.4905 18.2741 20.1507 18.0851L11.161 12.9651C11.0112 12.8811 10.8433 12.8391 10.6734 12.8181H10.5885C10.4186 12.8181 10.2488 12.8811 10.1009 12.9651L1.11121 18.0851C0.771482 18.2751 0.559654 18.6301 0.559654 19.0081L0.579638 32.7711C0.579128 32.866 0.604554 32.9592 0.653164 33.0406C0.701773 33.122 0.771714 33.1886 0.855414 33.2331C1.02528 33.3381 1.2371 33.3381 1.38498 33.2331L6.72764 30.2131C7.06737 30.0231 7.2792 29.6681 7.2792 29.2901V22.8501C7.2792 22.4721 7.49102 22.1161 7.83075 21.9271L10.0989 20.6271C10.2688 20.5221 10.4586 20.4801 10.6505 20.4801C10.8382 20.4737 11.0233 20.525 11.181 20.6271L13.4492 21.9271C13.7889 22.1171 14.0007 22.4721 14.0007 22.8501V29.2901C14.0007 29.6681 14.2126 30.0241 14.5523 30.2131L19.8949 33.2331C20.0648 33.3381 20.2766 33.3381 20.4465 33.2331C20.5302 33.1886 20.6001 33.122 20.6487 33.0406C20.6974 32.9592 20.7228 32.866 20.7223 32.7711L20.7023 19.0081ZM63.9122 0.0631132C63.8299 0.0216159 63.739 0 63.6469 0C63.5548 0 63.4639 0.0216159 63.3816 0.0631132C63.2118 0.168113 63.1058 0.336113 63.1058 0.523113V14.1601C63.1058 14.2861 63.0419 14.4121 62.916 14.4961C62.8572 14.5271 62.7917 14.5433 62.7252 14.5433C62.6587 14.5433 62.5932 14.5271 62.5343 14.4961L60.2861 13.2161C59.9514 13.0261 59.5397 13.0261 59.205 13.2161L50.2153 18.3561C49.8756 18.5461 49.6638 18.9011 49.6638 19.2791V29.5391C49.6638 29.9171 49.8756 30.2731 50.2153 30.4621L59.205 35.6021C59.5397 35.7921 59.9514 35.7921 60.2861 35.6021L69.2758 30.4621C69.6156 30.2721 69.8274 29.9171 69.8274 29.5391V3.96511C69.8274 3.56511 69.6156 3.21011 69.2758 3.02111L63.9122 0.0631132ZM63.0859 26.1631C63.0859 26.2681 63.0439 26.3531 62.959 26.3931L59.8845 28.1551C59.7975 28.1971 59.6946 28.1971 59.6087 28.1551L56.5342 26.3931C56.4493 26.3511 56.4073 26.2461 56.4073 26.1631V22.6381C56.4073 22.5331 56.4493 22.4481 56.5342 22.4081L59.6087 20.6461C59.6956 20.6041 59.7985 20.6041 59.8845 20.6461L62.959 22.4081C63.0439 22.4501 63.0859 22.5551 63.0859 22.6381V26.1631ZM93.8279 22.5531C94.1676 22.3631 94.3575 22.0081 94.3575 21.6301V19.1331C94.3553 18.9467 94.3054 18.764 94.2125 18.6024C94.1196 18.4408 93.9868 18.3057 93.8269 18.2101L84.9011 13.0901C84.5664 12.9001 84.1547 12.9001 83.82 13.0901L74.8303 18.2301C74.4906 18.4201 74.2788 18.7751 74.2788 19.1531V29.4131C74.2788 29.7911 74.4906 30.1471 74.8303 30.3361L83.7561 35.3711C84.0958 35.5611 84.4985 35.5611 84.8152 35.3711L90.2208 32.3911C90.3045 32.3466 90.3745 32.28 90.4231 32.1986C90.4717 32.1172 90.4971 32.024 90.4966 31.9291C90.4971 31.8343 90.4717 31.7411 90.4231 31.6596C90.3745 31.5782 90.3045 31.5116 90.2208 31.4671L81.1882 26.3271C81.0183 26.2221 80.9124 26.0541 80.9124 25.8671V22.6671C80.9119 22.5723 80.9373 22.4791 80.9859 22.3976C81.0345 22.3162 81.1045 22.2496 81.1882 22.2051L84.0079 20.6101C84.1777 20.5051 84.3906 20.5051 84.5594 20.6101L87.3791 22.2051C87.549 22.3101 87.6549 22.4781 87.6549 22.6671V25.1851C87.6546 25.2798 87.6801 25.3728 87.7287 25.454C87.7773 25.5353 87.8471 25.6017 87.9307 25.6461C88.1005 25.7511 88.3124 25.7511 88.4822 25.6461L93.8249 22.5621L93.8279 22.5531Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2237 22.0701C84.2876 22.0281 84.3716 22.0281 84.4355 22.0701L86.1541 23.0561C86.2181 23.0981 86.26 23.1611 86.26 23.2461V25.2181C86.2602 25.2561 86.2505 25.2935 86.2319 25.3266C86.2134 25.3597 86.1866 25.3875 86.1541 25.4071L84.4355 26.3931C84.3716 26.4351 84.2876 26.4351 84.2237 26.3931L82.5051 25.4071C82.4726 25.3875 82.4458 25.3597 82.4273 25.3266C82.4087 25.2935 82.399 25.2561 82.3992 25.2181V23.2461C82.3992 23.1621 82.4411 23.0991 82.5051 23.0561L84.2237 22.0701Z",
    fill: "#539E43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7341 13.1331C35.3994 12.9431 34.9877 12.9431 34.653 13.1331L25.7272 18.2311C25.3875 18.4211 25.1976 18.7761 25.1976 19.1541V29.3721C25.1998 29.5585 25.2497 29.7413 25.3426 29.9029C25.4355 30.0645 25.5683 30.1995 25.7282 30.2951L34.654 35.3931C34.9887 35.5831 35.4004 35.5831 35.7351 35.3931L44.6608 30.2951C45.0006 30.1051 45.1904 29.7501 45.1904 29.3721V19.1541C45.1882 18.9677 45.1383 18.7849 45.0454 18.6233C44.9525 18.4617 44.8198 18.3267 44.6598 18.2311L35.7341 13.1331Z",
    fill: "url(#paint0_linear_1175_860)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1175_860",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 12,
    width: 21,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7341 13.1331C35.3994 12.9431 34.9877 12.9431 34.653 13.1331L25.7272 18.2311C25.3875 18.4211 25.1976 18.7761 25.1976 19.1541V29.3721C25.1998 29.5585 25.2497 29.7413 25.3426 29.9029C25.4355 30.0645 25.5683 30.1995 25.7282 30.2951L34.654 35.3931C34.9887 35.5831 35.4004 35.5831 35.7351 35.3931L44.6608 30.2951C45.0006 30.1051 45.1904 29.7501 45.1904 29.3721V19.1541C45.1882 18.9677 45.1383 18.7849 45.0454 18.6233C44.9525 18.4617 44.8198 18.3267 44.6598 18.2311L35.7341 13.1331Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1175_860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.682 18.2311L35.7042 13.1331C35.6243 13.0791 35.5344 13.0541 35.4385 13.0291L25.3886 30.0641C25.4716 30.1641 25.5725 30.2501 25.6854 30.3161L34.6541 35.4141C34.9089 35.5611 35.2057 35.6041 35.4804 35.5191L44.9168 18.4411C44.8492 18.3604 44.7705 18.2897 44.683 18.2311H44.682Z",
    fill: "url(#paint1_linear_1175_860)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1175_860",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 12,
    width: 21,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7341 13.1331C35.3994 12.9431 34.9877 12.9431 34.653 13.1331L25.7272 18.2311C25.3875 18.4211 25.1976 18.7761 25.1976 19.1541V29.3721C25.1998 29.5585 25.2497 29.7413 25.3426 29.9029C25.4355 30.0645 25.5683 30.1995 25.7282 30.2951L34.654 35.3931C34.9887 35.5831 35.4004 35.5831 35.7351 35.3931L44.6608 30.2951C45.0006 30.1051 45.1904 29.7501 45.1904 29.3721V19.1541C45.1882 18.9677 45.1383 18.7849 45.0454 18.6233C44.9525 18.4617 44.8198 18.3267 44.6598 18.2311L35.7341 13.1331Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1175_860)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7028 30.2951C44.9576 30.1481 45.1484 29.8951 45.2324 29.6251L35.3944 13.0091C35.1396 12.9671 34.8648 12.9891 34.631 13.1351L25.7272 18.2111L35.3314 35.5411C35.4709 35.5184 35.6065 35.476 35.7341 35.4151L44.7028 30.2951Z",
    fill: "url(#paint2_linear_1175_860)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7028 30.2951L35.7561 35.3931C35.6297 35.4569 35.4936 35.4995 35.3534 35.5191L35.5233 35.8341L45.4452 30.1491V30.0231L45.1904 29.6031C45.1484 29.8971 44.9576 30.1481 44.7028 30.2951Z",
    fill: "url(#paint3_linear_1175_860)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7028 30.2951L35.7561 35.3931C35.6297 35.4569 35.4936 35.4995 35.3534 35.5191L35.5233 35.8341L45.4452 30.1491V30.0231L45.1904 29.6031C45.1484 29.8971 44.9576 30.1481 44.7028 30.2951Z",
    fill: "url(#paint4_linear_1175_860)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1175_860",
    x1: 38.059,
    y1: 16.933,
    x2: 30.315,
    y2: 32.5382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1175_860",
    x1: 34.1652,
    y1: 25.4605,
    x2: 53.1616,
    y2: 11.5929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1175_860",
    x1: 24.8711,
    y1: 24.265,
    x2: 45.5247,
    y2: 24.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1175_860",
    x1: 24.8719,
    y1: 32.7357,
    x2: 45.5256,
    y2: 32.7357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1175_860",
    x1: 48.5346,
    y1: 26.5272,
    x2: 42.1215,
    y2: 39.4522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.83380670ed6ef83d8d29ff8a5b3cee63.svg";
export { ForwardRef as ReactComponent };